/* bm_peakExplorer_ui.js – Zahleneingabe (kurze Seite km) + Scale-UI-API */
(function () {
  window.BM = window.BM || {};
  if (window.BM.__peakExplorerUiLoaded) return;
  window.BM.__peakExplorerUiLoaded = true;

  function attachUI(rootEl, initialKm, onDiameterChange) {
    const U = window.BM.util;
    const num        = rootEl?.querySelector?.('[data-role="edge-number"]');
    const scaleLabel = rootEl?.querySelector?.('[data-role="scale-label"]');
    const slider     = rootEl?.querySelector?.('[data-role="scale-slider"]');

    if (!U || !num || typeof onDiameterChange !== 'function') return {
      setDiameter(){}, setScaleLabel(){}, setScaleSlider(){}, destroy(){}
    };

    const N_MIN  = Number(num.min || 1);
    const N_MAX  = Number(num.max || 100);
    const N_STEP = Number(num.step || 0.1);

    const normalize = (v) => {
      const val = Number(String(v).replace(',', '.'));
      if (!Number.isFinite(val)) return current;
      const n = U.roundTo(val, N_STEP);
      return U.clamp(n, N_MIN, N_MAX);
    };

    let current = U.clamp(Number(initialKm), N_MIN, N_MAX);
    if (!Number.isFinite(current)) current = N_MIN;
    current = normalize(current);
    num.value = String(current);

    // gedrosselte Live-Reaktion beim „input“
    const onInputThrottled = U.rafThrottle(() => {
      const raw = Number(String(num.value).replace(',', '.'));
      if (Number.isNaN(raw)) return;
      const n = U.clamp(raw, N_MIN, N_MAX);
      // nur reagieren, wenn sich der Wert spürbar änderte
      if (U.changed(n, current, 1e-3)) {
        current = n;
        onDiameterChange(current, false);
      }
    });
    num.addEventListener('input', onInputThrottled, { passive: true });

    // Commit bei Enter/Blur
    const commit = () => {
      const n = normalize(num.value);
      if (!U.nearlyEqual(n, current, 1e-6)) {
        current = n;
        num.value = String(current);
        onDiameterChange(current, true);
      } else {
        num.value = String(current);
      }
    };
    const onKeydown = (event) => {
      if (event.key !== 'Enter') return;
      commit();
      num.blur();
    };

    num.addEventListener('keydown', onKeydown);
    num.addEventListener('change', commit);
    num.addEventListener('blur', commit);

    return {
      setDiameter: (v, fit=false) => {
        const n = normalize(v);
        if (!U.nearlyEqual(n, current)) {
          current = n; num.value = String(n);
          onDiameterChange(n, fit);
        } else {
          num.value = String(n);
        }
      },
      setScaleLabel: (denom) => {
        if (scaleLabel) scaleLabel.textContent = Number(denom).toLocaleString('de-DE');
      },
      setScaleSlider: (denom, min, max) => {
        if (!slider) return;
        const value = Math.min(max, Math.max(min, denom));
        slider.value = String(value);
        slider.setAttribute('aria-valuetext', `Maßstab 1 zu ${Number(value).toLocaleString('de-DE')}`);
      },
      destroy: () => {
        onInputThrottled.cancel?.();
        num.removeEventListener('input', onInputThrottled);
        num.removeEventListener('keydown', onKeydown);
        num.removeEventListener('change', commit);
        num.removeEventListener('blur', commit);
      }
    };
  }

  window.BM.attachUI = attachUI;
})();
